import { z } from 'zod';

export const TrackingUrl = z.object({
  originalUrl: z.string(),
  trackingUrl: z.string(),
  shortUrl: z.string().optional(),
});
export type TrackingUrl = z.infer<typeof TrackingUrl>;

export const TrackingUrlArray = z.array(TrackingUrl);
export type TrackingUrlArray = z.infer<typeof TrackingUrlArray>;
